import { styled } from "theme/default/styled";

import { SGroupUserCellTitle } from "./SGroupUserCellTitle.styled";

export const SGroupUserCellTitleButton = styled(SGroupUserCellTitle)`
  cursor: pointer;
`;
